Qs = require 'qs'
_ = require 'lodash'
extend = require 'extend'

config = require 'oo-config'

exports.routes =
  print: require './routes/print'
  dashboard: require './routes/dashboard'
  dashboard2: require './routes/dashboard2'
  query: require './routes/query'
  manager: require './routes/manager'
  ecommerce: require './routes/ecommerce'
  ecommerce2: require './routes/ecommerce2'
  embrServer: require './routes/embrServer'
  employee: require './routes/employee'
  fileServer: require './routes/fileServer'
  order: require './routes/order'
  order2: require './routes/order2'
  order3: require './routes/order3'
  website: require './routes/website'
  website2: require './routes/website2'
  email: require './routes/email'
  printer: require './routes/printer'
  updater: require './routes/updater'
  webcam: require './routes/webcam'
  alpha: require './routes/alpha'
  autobagger: require './routes/autobagger'
  sanmar: require './routes/sanmar'
  manager2: require './routes/manager2'
  ping: require './routes/ping'
  netsuite: require './routes/netsuite'
  packingSlip: require './routes/packingSlip'
  graphql: require './routes/graphql'
  mockupServer: require './routes/mockupServer'
  mockupQuery: require './routes/mockupQuery'
  mockupTools: require './routes/mockupTools'
  promoStandards: require './routes/promoStandards'
  coupa: require './routes/coupa'
  statement: require './routes/statement'
  integrations: require './routes/integrations'
  authServer: require './routes/authServer'
  camera: require './routes/camera'
  featureFlag: require './routes/featureFlag'
  common: require './routes/common'
  orderForm: require './routes/orderForm.coffee'

# url 'billing', '/v2/billing/:billingId/totals', {billingId: 'x'}
#  => 'http://localhost:3002/v2/billing/x/totals'

exports.url = (service, path, params = {}) ->
  protocol = config[service]?.protocol || 'http'
  host = config[service]?.host || 'localhost'
  port = config[service]?.port || ''
  externalPort = config[service]?.externalPort

  if config[service]?.dockerHost
    host = config[service]?.dockerHost

  url = "#{protocol}://#{host}"
  if !externalPort && port then url += ":#{port}"
  if externalPort? && externalPort != 80 then url += ":#{externalPort}"

  return url + urlPath(path, params)

# path '/test/:a/:b', {a: 1, b: 2, c: 3}, {d: 4, e: 5}
# changes /test/:a/:b
#      to /test/1/2?c=3#?d=4&=e
#
exports.path = urlPath = (path, params = {}, hash = {}) ->
  params = extend {}, params # Make a copy, to prevent modifying input
  seen = {}
  path = path.replace /((\/|\.):\w+\??)/g, (m, p1) ->
    leading = m[0]
    required = !~p1.indexOf '?'
    param = p1.replace /[\/\.:?]/g, ''
    seen[param] = true
    if required && not params[param]?
      return "#{leading}:#{param}"
    return if params[param]? then "#{leading}#{params[param]}" else ''
  for key, val of params when seen[key]
    delete params[key]

  if qs = Qs.stringify(params)
    path += "?#{qs}"

  if qs = Qs.stringify(hash)
    path += "#?#{qs}"

  return path

# params '/v2/billing/12345/totals', routes.billing.account.totals
# => { billingId: 12345}
exports.params = (path, route) ->
  params = route.match /\/:\w+\??/g, route
  matchRoute = route.replace /\/:\w+\??/g, '/(.*)'
  match = path.match matchRoute
  result = {}
  for param, idx in params
    param = param.replace /^\/:/, ''
    value = match[idx + 1] # idx 0 is reserved for the entire match
    result[param] = value
  return result


exports.routeList = routeList = (routeObject) ->
  return [routeObject] if typeof routeObject == 'string'
  list = []
  for key, val of routeObject
    if typeof val == 'string'
      list.push val
    else if typeof val == 'object'
      list.push routeList(val)...
  return list

updateObj = (obj, update) ->
  for key, value of update
    if _.isNull(value) # Only unset value if it is specifically set to null
      delete obj[key]
    else if _.isPlainObject(value) && _.isPlainObject(obj[key])
      updateObj(obj[key], value)
    else
      obj[key] = value

exports.updateURLQuery = updateURLQuery = (path, query, update, options) ->
  [path, pathQuery] = path.split('?')
  queryObj = Qs.parse pathQuery, options
  queryObj = _.merge queryObj, query
  updateObj(queryObj, update)
  return "#{path}?#{Qs.stringify(queryObj, options)}".replace(/\?$/, '')



// WEBPACK FOOTER //
// ./~/oo-routes/public.coffee